export const GET_DOMAIN_DATA_REQUEST = 'GET_DOMAIN_DATA_REQUEST';
export const GET_DOMAIN_DATA_SUCCESS = 'GET_DOMAIN_DATA_SUCCESS';
export const GET_DOMAIN_DATA_FAILED = 'GET_DOMAIN_DATA_FAILED';
export const GET_DOMAIN_DATA_CLEAR = 'GET_DOMAIN_DATA_CLEAR';

export const GET_NO_COMMERCIAL_REASONS_REQUEST =
  'GET_NO_COMMERCIAL_REASONS_REQUEST';
export const GET_NO_COMMERCIAL_REASONS_SUCCESS =
  'GET_NO_COMMERCIAL_REASONS_SUCCESS';
export const GET_NO_COMMERCIAL_REASONS_FAILED =
  'GET_NO_COMMERCIAL_REASONS_FAILED';

export const GET_IMAGE_DATA_REQUEST = 'GET_IMAGE_DATA_REQUEST';
export const GET_IMAGE_DATA_SUCCESS = 'GET_IMAGE_DATA_SUCCESS';
export const GET_IMAGE_DATA_FAILED = 'GET_IMAGE_DATA_FAILED';
export const GET_IMAGE_DATA_CLEAR = 'GET_IMAGE_DATA_CLEAR';

export const GET_LANGUAGES_REQUEST = 'GET_LANGUAGES_REQUEST';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_FAILED = 'GET_LANGUAGES_FAILED';
export const GET_LANGUAGES_CLEAR = 'GET_LANGUAGES_CLEAR';

export const GET_IMAGES_TABLE_AGENCIES_REQUEST =
  'GET_IMAGES_TABLE_AGENCIES_REQUEST';
export const GET_IMAGES_TABLE_AGENCIES_SUCCESS =
  'GET_IMAGES_TABLE_AGENCIES_SUCCESS';
export const GET_IMAGES_TABLE_AGENCIES_FAILED =
  'GET_IMAGES_TABLE_AGENCIES_FAILED';
